import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {ROUTER_NAVIGATED, ROUTER_NAVIGATION, RouterNavigatedAction, RouterNavigationAction} from '@ngrx/router-store';
import {Store} from '@ngrx/store';
import {tap, withLatestFrom} from 'rxjs/operators';
import {buildPageViewAttributes} from '../../observability/analytics.config';
import {AnalyticsService} from '../../services/analytics.service';
import {selectOrganizationName} from '../organization/organization.selectors';
import * as routerActions from './router.actions';

@Injectable()
export class RouterEffects {
  logNavigation$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATION),
        tap((action: RouterNavigationAction) => {
          // Add to history for all navigation types except initial page load
          const navTrigger = (action.payload.event as any)?.navigationTrigger;
          const isInitialLoad = navTrigger === 'imperative' && action.payload.event?.id === 1;
          if (!isInitialLoad) {
            this.store.dispatch(routerActions.addNavigationHistory({url: action.payload.routerState.url}));
          }
        })
      ),
    {dispatch: false}
  );

  trackPageView$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATED),
        withLatestFrom(this.store.select(selectOrganizationName)),
        tap(([action, orgName]: [RouterNavigatedAction, string | undefined]) => {
          const attributes = buildPageViewAttributes(action.payload.routerState, orgName);
          this.analytics.trackPageView(attributes);
        })
      ),
    {dispatch: false}
  );

  constructor(
    private actions$: Actions,
    private store: Store,
    private analytics: AnalyticsService
  ) {}
}
